import { jsx as o } from "react/jsx-runtime";
import { useSpring as f, a as l } from "@react-spring/web";
import { Ui as N } from "../Ui/Ui.js";
import { css as t } from "../apps/ui/styled-system/css/css.js";
const S = [
  {
    diff: -60,
    progression: [
      [0, 0.2, 0.5, 1],
      [0, 0.5, 0.8, 1]
    ]
  },
  {
    diff: 60,
    progression: [
      [0, 1],
      [0, 1]
    ]
  }
];
function w({
  animateMount: n,
  color: s,
  padding: a,
  size: r = "medium",
  thickness: i
}) {
  a ?? (a = 1), s ?? (s = "currentColor"), r === "large" && (r = 32), r === "medium" && (r = 20), r === "small" && (r = 16), i ?? (i = r / 10);
  const e = N.useUi(!0), p = f({
    config: {
      friction: 200,
      mass: 3,
      precision: 0.1,
      tension: e != null && e.reducedMotion ? 5 : 300
    },
    from: { progress: 0 },
    loop: !0,
    to: { progress: 1 }
  }), g = f({
    config: {
      friction: 80,
      mass: 2,
      tension: 2e3
    },
    from: {
      opacity: n ? 0 : 1,
      transform: `scale(${n ? 0 : 1})`
    },
    to: {
      opacity: 1,
      transform: "scale(1)"
    }
  }), c = r / 2 - a - i / 2, m = 2 * c * Math.PI;
  return /* @__PURE__ */ o(
    l.div,
    {
      className: t({
        position: "relative"
      }),
      style: {
        height: r,
        width: r,
        ...g
      },
      children: /* @__PURE__ */ o(
        "svg",
        {
          className: t({
            inset: 0,
            position: "absolute"
          }),
          fill: "none",
          height: r,
          role: "presentation",
          width: r,
          children: /* @__PURE__ */ o(
            "g",
            {
              className: t({
                animation: "spin 1s linear infinite",
                transformOrigin: "50% 50%"
              }),
              children: S.map(({ diff: d, progression: u }, h) => /* @__PURE__ */ o(
                l.circle,
                {
                  className: t({
                    transformOrigin: "50% 50%"
                  }),
                  cx: "50%",
                  cy: "50%",
                  r: c,
                  shapeRendering: "geometricPrecision",
                  stroke: s,
                  strokeDasharray: m,
                  strokeDashoffset: m / 2,
                  strokeLinecap: "round",
                  strokeWidth: i,
                  style: {
                    transform: p.progress.to(...u).to((y) => `rotate3d(0, 0, 1, ${d + y * 360}deg)`)
                  }
                },
                h
              ))
            }
          )
        }
      )
    }
  );
}
export {
  w as Spinner
};
//# sourceMappingURL=Spinner.js.map
